
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ustoz/[teacher]",
      function () {
        return require("private-next-pages/ustoz/[teacher].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ustoz/[teacher]"])
      });
    }
  